export const serviceLevels = ["", "4\"+","2\"+","1\"+","Any",]